import { reportUncaughtException } from 'src/utils/rollbar';

export default () =>
  window.onerror = reportUncaughtException;
